import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { BASE_URL } from '~/config';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function absoluteUrl(path: string) {
  return `${BASE_URL}${path}`;
}

export const truncate = (text: string, length: number) => {
  if (text && text.length > length) {
    return `${text.slice(0, Math.max(0, length))}...`;
  }
  return text;
};

export function ucfirst(str: string) {
  if (!str) return undefined;
  if (str.length < 2) return str.toUpperCase();
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

export function camel2spaced(str: string) {
  return str?.replace(/([A-Z])/g, ' $1').toLowerCase();
}
